import { render, staticRenderFns } from "./RepoTreeNode.vue?vue&type=template&id=5876d342&scoped=true"
import script from "./RepoTreeNode.vue?vue&type=script&lang=js"
export * from "./RepoTreeNode.vue?vue&type=script&lang=js"
import style0 from "./RepoTreeNode.vue?vue&type=style&index=0&id=5876d342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876d342",
  null
  
)

export default component.exports